<template>
    <div
        class="aon-col"
        :style="computedStyles"
    >
        <slot></slot>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    order: {
        type: String || Number,
        default: null,
    },
    alignSelf: {
        type: String,
        default: null,
        validator: (val) => ['auto', 'start', 'end', 'center', 'baseline', 'stretch'].includes(val),
    },
    alignItems: {
        type: String,
        default: null,
        validator: (val) => {
            return ['center', 'start', 'end', 'flex-start', 'flex-end', 'normal'].includes(val)
        }
    },
    alignContent: {
        type: String,
        default: null,
        validator: (val) => {
            return ['center', 'start', 'end', 'flex-start', 'flex-end', 'normal'].includes(val)
        }
    },
    justifyContent: {
        type: String,
        default: null,
        validator: (val) => {
            return ['center', 'start', 'end', 'flex-start', 'flex-end', 'normal', 'left', 'right', 'space-between', 'space-around', 'space-evenly'].includes(val)
        }
    },
    removePadding: {
        type: Array,
        validator: (val) => {
            return val.some(item => ['x', 'y', 'a', 'l', 'r', 't', 'b'].includes(item))
        }
    },
})

const computedStyles = computed(() => {
    let paddingRemovalObj = {}
    if (props.removePadding) {
        paddingRemovalObj = {
            'padding-left': props.removePadding.includes('l') ? '0': null,
            'padding-right': props.removePadding.includes('r') ? '0': null,
            'padding-top': props.removePadding.includes('t') ? '0': null,
            'padding-bottom': props.removePadding.includes('b') ? '0': null,
        }
    }
    const otherPropClasses = {
        'order': props.order,
        'align-self': props.alignSelf,
        'align-items': props.alignItems,
        'align-content': props.alignContent,
        'justify-content': props.justifyContent
    }
    const finalClassObj = {...paddingRemovalObj, ...otherPropClasses}
    return finalClassObj
})
</script>

<script>
    export default {
        name: 'AonCol'
    }
</script>

<style lang="scss">
@import '../../../sass/grid.scss';

.aon-col {
    display: flex;
    padding: $gutter;
    flex-wrap: wrap;
    width: 100%;
}
</style>
